import { render, staticRenderFns } from "./new_email_task_list.vue?vue&type=template&id=7c19bbfc&scoped=true&"
import script from "./new_email_task_list.vue?vue&type=script&lang=js&"
export * from "./new_email_task_list.vue?vue&type=script&lang=js&"
import style0 from "./new_email_task_list.vue?vue&type=style&index=0&id=7c19bbfc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c19bbfc",
  null
  
)

export default component.exports